module.exports = __webpack_public_path__ + "img/stormandsea.948b1792.png";